// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.travel-info__distance-section[data-v-27a017a2] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
